import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoClose } from '../../node_modules/react-icons/io5/index.esm.js';
import Header from '../Header/index.js';
import { genericMemo } from '../../utils/index.js';
import Footer from '../Footer/index.js';
import Button from '../Button/index.js';
import BodyBackdrop from '../BodyBackdrop/index.js';
import styles from './styles.css.js';

var _IoClose;
const sizeToStyleMap = {
  free: styles.freeSize,
  extraSmall: styles.extraSmallSize,
  small: styles.smallSize,
  medium: styles.mediumSize,
  large: styles.largeSize,
  cover: styles.coverSize
};
const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Modal(props) {
  const {
    heading,
    children,
    footer,
    className,
    backdropClassName,
    headerClassName,
    bodyClassName,
    footerClassName,
    headingSectionClassName,
    headingDescription,
    headingChildrenClassName,
    headerDescriptionClassName,
    closeButtonClassName,
    footerIconsContainerClassName,
    footerActionsContainerClassName,
    footerContentClassName,
    footerQuickActionsContainerClassName,
    headingClassName,
    inlineHeadingDescription,
    headingContainerClassName,
    footerActions,
    footerIcons,
    headerActions,
    headerIcons,
    footerQuickActions,
    headingSize,
    spacing = 'loose',
    size = 'medium',
    freeHeight,
    movable = false
  } = props; // eslint-disable-next-line react/destructuring-assignment

  const shouldHideHeader = props.hideCloseButton && !heading && !headerActions && !headerIcons;
  const headerRef = React.useRef(null);
  const modalRef = React.useRef(null);
  const mouseDownRef = React.useRef(false);
  const mouseDownPositionDiffRef = React.useRef({
    x: 0,
    y: 0
  });
  const initialBCRRef = React.useRef();
  React.useEffect(() => {
    var _modalRef$current;

    initialBCRRef.current = (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.getBoundingClientRect();
  }, []);
  React.useEffect(() => {
    const headerElement = headerRef.current;
    const modalElement = modalRef.current;

    if (!movable || !headerElement || !modalElement) {
      return undefined;
    }

    const handleMouseMove = e => {
      const bcr = initialBCRRef.current;

      if (bcr) {
        const translateX = e.clientX - mouseDownPositionDiffRef.current.x - bcr.x;
        const translateY = e.clientY - mouseDownPositionDiffRef.current.y - bcr.y;
        modalElement.style.transform = `translate(${translateX}px, ${translateY}px)`;
      }
    };

    const handleMouseDown = e => {
      var _modalRef$current2;

      mouseDownRef.current = true;
      const currentBCR = (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.getBoundingClientRect();

      if (currentBCR) {
        mouseDownPositionDiffRef.current.x = e.clientX - currentBCR.x;
        mouseDownPositionDiffRef.current.y = e.clientY - currentBCR.y;
      }

      window.addEventListener('mousemove', handleMouseMove);
    };

    const handleMouseUp = () => {
      mouseDownRef.current = false;
      window.removeEventListener('mousemove', handleMouseMove);
    };

    if (movable) {
      headerElement.addEventListener('mousedown', handleMouseDown);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      headerElement.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [movable]);
  return /*#__PURE__*/React.createElement(BodyBackdrop, {
    className: backdropClassName
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: _cs(styles.modal, spacingToStyleMap[spacing], sizeToStyleMap[size], freeHeight && styles.freeHeight, className, movable && styles.movable)
  }, !shouldHideHeader && /*#__PURE__*/React.createElement(Header, {
    elementProps: movable ? {
      ref: headerRef
    } : undefined,
    spacing: spacing,
    className: _cs(styles.modalHeader, headerClassName),
    heading: heading,
    headingSectionClassName: headingSectionClassName,
    childrenContainerClassName: headingChildrenClassName,
    headingSize: headingSize,
    description: headingDescription,
    descriptionClassName: headerDescriptionClassName,
    headingClassName: headingClassName,
    headingContainerClassName: headingContainerClassName,
    inlineHeadingDescription: inlineHeadingDescription,
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, headerActions, // eslint-disable-next-line react/destructuring-assignment
    !props.hideCloseButton && /*#__PURE__*/React.createElement(Button, {
      className: closeButtonClassName // eslint-disable-next-line max-len
      // eslint-disable-next-line react/destructuring-assignment
      ,
      onClick: props.onCloseButtonClick,
      name: "close-modal",
      variant: "action"
    }, _IoClose || (_IoClose = /*#__PURE__*/React.createElement(IoClose, null))))
  }), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.modalBody, bodyClassName)
  }, children), (footer || footerIcons || footerActions || footerQuickActions) && /*#__PURE__*/React.createElement(Footer, {
    spacing: spacing,
    className: _cs(styles.modalFooter, footerClassName),
    icons: footerIcons,
    actions: footerActions,
    iconsContainerClassName: footerIconsContainerClassName,
    childrenContainerClassName: footerContentClassName,
    actionsContainerClassName: footerActionsContainerClassName,
    quickActionsContainerClassName: footerQuickActionsContainerClassName,
    quickActions: footerQuickActions
  }, footer)));
}

var Modal$1 = genericMemo(Modal);

export { Modal$1 as default };
//# sourceMappingURL=index.js.map
